const convertUrlToFile = async (url: RequestInfo | URL, fileName: string) => {
  try {
    const response = await fetch(url);
    const blob = await response.blob();

    // Create a File object from the Blob
    const file = new File([blob], fileName, { type: blob.type });

    return file;
  } catch (error) {
    console.error("Error converting URL to file:", error);
  }
};

export default convertUrlToFile;
